/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/**
 * Created by MinhQuan on 12/22/2015.
 */

angular.module('common.template.footnote.popup',['common.filter.description', 'common.filter.specialCharacterToHtml']).controller('FootnotePopupController',
    function($uibModalInstance, footnote, CONSTANTS){
        var  footnotePopupCtrl = this;
        footnotePopupCtrl.dateFormat = CONSTANTS.dateFormat;
        footnotePopupCtrl.footnote = footnote;
        footnotePopupCtrl.close = function (){
            $uibModalInstance.dismiss('Close');
        };
    });







// WEBPACK FOOTER //
// ./app/common/popup/footnote/footnote-popup.js